import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForecastBrokerService {
  public scenarioSelectionChanged: BehaviorSubject<any>;
  public cellDoubleClicked: BehaviorSubject<any>;

  constructor() {
    this.scenarioSelectionChanged = new BehaviorSubject(null);
    this.cellDoubleClicked = new BehaviorSubject(null);
  }
}